"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDisableCacheMiddleware = void 0;
var createDisableCacheMiddleware_1 = require("./createDisableCacheMiddleware");
Object.defineProperty(exports, "createDisableCacheMiddleware", { enumerable: true, get: function () { return createDisableCacheMiddleware_1.createDisableCacheMiddleware; } });
